import { apiFetch } from './api';

/**
 * Phase 21 frontend mirror of the read-only analytics API.
 *
 * GET-only by construction: this module exposes a single fetch helper and
 * no mutation of any kind. The response carries aggregate counts and UTC
 * day labels only — the backend never returns message contents, tokens,
 * payloads, or row-level data, so there is nothing sensitive to handle
 * here.
 */

export interface DailyExecutionBucket {
  date: string;
  count: number;
}

/** Exactly the five statuses the backend counts (schema CHECK vocabulary). */
export interface ExecutionStatusBreakdown {
  pending: number;
  pending_retry: number;
  success: number;
  failed: number;
  blocked: number;
}

export interface AnalyticsSummaryResponse {
  generated_at: number;
  window_days: number;
  executions: {
    total: number;
    by_status: ExecutionStatusBreakdown;
  };
  automations: {
    total: number;
    enabled: number;
  };
  connected_accounts: number;
  conversations: number;
  inbound_messages: number;
  received_webhook_events: number;
  daily_executions: DailyExecutionBucket[];
}

/** Windows offered by the dashboard selector — all valid backend values. */
export const ANALYTICS_WINDOW_OPTIONS = [7, 14, 30] as const;

export const DEFAULT_WINDOW_DAYS = 14;

export function getAnalyticsRequest(days: number): Promise<AnalyticsSummaryResponse> {
  return apiFetch<AnalyticsSummaryResponse>(`/api/analytics?days=${days}`);
}
